export type PlayerBreadcrumb = {
  t: number;
  tag: string;
  data?: unknown;
};

export class PlayerLogger {
  private max: number;
  private events: PlayerBreadcrumb[] = [];

  constructor(max = 300) {
    this.max = Math.max(10, Number(max || 300));
  }

  log(tag: string, data?: unknown) {
    try {
      this.events.push({ t: Date.now(), tag, data });
      if (this.events.length > this.max) this.events.splice(0, this.events.length - this.max);
    } catch {
      // ignore
    }
  }

  list(): PlayerBreadcrumb[] {
    return this.events.slice();
  }

  clear() {
    this.events = [];
  }
}


